// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.label__checkbox {
    display: none;
}

.label__check {
    border-radius: 50%;
    border: 4px solid rgba(0, 0, 0, 0.1);
    background-color: white;
    vertical-align: middle;
    width: 22px;
    height: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border .4s ease;
}

.icon {
    top: 0px;
    left: 0px;
    opacity: .2;
    font-size: 10px;
    color: transparent;
    transform: scale(.8);
    transition: opacity .4s .1s ease;
    -webkit-text-stroke: 3px rgba(0, 0, 0, 0.5);
}

.label__check:hover {
    border: 4px solid rgba(0, 0, 0, 0.2);
}

.label__checkbox:checked+.label__text .label__check {
    animation: check .5s cubic-bezier(1, .03, 0.7, 0.2) forwards;
}

.label__checkbox:checked+.label__text .label__check .icon {
    opacity: 1;
    transform: scale(0);
    color: white;
    -webkit-text-stroke: 0;
    /* transform: translate(-50%, -50%); */
    animation: icon .3s cubic-bezier(1, .01, .5, 1.6) .15s forwards;
}


@keyframes icon {
    from {
        opacity: 0;
        color: white;
        transform: scale(.3);
    }

    to {
        opacity: 1;
        color: white;
        transform: scale(1);
    }
}


@keyframes check {
    0% {
        width: 15px;
        height: 15px;
    }

    10% {
        width: 15px;
        height: 15px;
        opacity: 0.1;
        background-color: rgba(0, 0, 0, 0.2);
    }

    15% {
        width: 15px;
        height: 15px;
        opacity: .4;
        background-color: rgba(0, 0, 0, 0.1);
        border-width: 0;
    }

    50% {
        width: 22px;
        height: 22px;
        opacity: .6;
        background: #0066B2;
        border: 0;
    }

    100% {
        width: 22px;
        height: 22px;
        opacity: 1;
        background: #0066B2;
        border: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/round-checkbox/round-checkbox.component.css"],"names":[],"mappings":";AACA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,sCAAsC;IACtC,+DAA+D;AACnE;;;AAGA;IACI;QACI,UAAU;QACV,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;IACvB;AACJ;;;AAGA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,oCAAoC;IACxC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,WAAW;QACX,oCAAoC;QACpC,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,SAAS;IACb;AACJ","sourcesContent":["\n.label__checkbox {\n    display: none;\n}\n\n.label__check {\n    border-radius: 50%;\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    background-color: white;\n    vertical-align: middle;\n    width: 22px;\n    height: 22px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: border .4s ease;\n}\n\n.icon {\n    top: 0px;\n    left: 0px;\n    opacity: .2;\n    font-size: 10px;\n    color: transparent;\n    transform: scale(.8);\n    transition: opacity .4s .1s ease;\n    -webkit-text-stroke: 3px rgba(0, 0, 0, 0.5);\n}\n\n.label__check:hover {\n    border: 4px solid rgba(0, 0, 0, 0.2);\n}\n\n.label__checkbox:checked+.label__text .label__check {\n    animation: check .5s cubic-bezier(1, .03, 0.7, 0.2) forwards;\n}\n\n.label__checkbox:checked+.label__text .label__check .icon {\n    opacity: 1;\n    transform: scale(0);\n    color: white;\n    -webkit-text-stroke: 0;\n    /* transform: translate(-50%, -50%); */\n    animation: icon .3s cubic-bezier(1, .01, .5, 1.6) .15s forwards;\n}\n\n\n@keyframes icon {\n    from {\n        opacity: 0;\n        color: white;\n        transform: scale(.3);\n    }\n\n    to {\n        opacity: 1;\n        color: white;\n        transform: scale(1);\n    }\n}\n\n\n@keyframes check {\n    0% {\n        width: 15px;\n        height: 15px;\n    }\n\n    10% {\n        width: 15px;\n        height: 15px;\n        opacity: 0.1;\n        background-color: rgba(0, 0, 0, 0.2);\n    }\n\n    15% {\n        width: 15px;\n        height: 15px;\n        opacity: .4;\n        background-color: rgba(0, 0, 0, 0.1);\n        border-width: 0;\n    }\n\n    50% {\n        width: 22px;\n        height: 22px;\n        opacity: .6;\n        background: #0066B2;\n        border: 0;\n    }\n\n    100% {\n        width: 22px;\n        height: 22px;\n        opacity: 1;\n        background: #0066B2;\n        border: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
